import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import DynamicTable from "../extras/DynamicTable";
import {Helmet} from "react-helmet";
import {Breadcrumb, Button} from "semantic-ui-react";
import CustomDivider from "../extras/CustomDivider";
import Auth from "../../data/auth";
import GLOBAL from "../../data/globals";

class ProductsCurrentOpenBox extends Component {

    buttonDownloadReport = () => {
        return <div style={{margin:6}}>
            <Button fluid content='Descargar Reporte' onClick={()=>this.handleDownloadReport({})}/>
        </div>;
    }

    constructor(props) {
        super(props);

        let other_actions_components =[
            this.buttonDownloadReport
        ]

        this.state = {
            table_product_sales: {
                headers: ['Producto', 'Unidades Vendidas'],
                name: 'Producto',
                title: 'Productos Vendidos',
                pagination: true,
                url: `sales/current-open-box/products`,
                values: ['id', 'name', 'total'],
                other_actions_components: other_actions_components,
                id: 'box_detail_product_sales'
            },
        };
    }

    handleDownloadReport = () => {
        Auth.tokenUID().then(res => {
            if(res.token){
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = `${GLOBAL.BASE_URL}sales/current-open-box/products/download-xls?token=${res.token}&uid=${res.uid}&`;
                link.click();
            }
        }).catch((error) => console.log(error));
    };

    render() {
        return <div>
            <Helmet>
                <title>Quipuu - Vender</title>
            </Helmet>
            <Breadcrumb>
                <Breadcrumb.Section as={Link} to='/sale'>Vender</Breadcrumb.Section>
                <Breadcrumb.Divider/>
                <Breadcrumb.Section active>Productos Vendidos</Breadcrumb.Section>
            </Breadcrumb>
            <CustomDivider/>
            <DynamicTable {...this.state.table_product_sales} />
        </div>;
    }
}

export default withRouter(ProductsCurrentOpenBox);



// WEBPACK FOOTER //
// ./src/components/open_box/ProductsCurrentOpenBox.js